//import 'babel-polyfill'
import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import axios from 'axios'
import DatetimePicker from "vuetify-datetime-picker";
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

// add these before Vue is instantiated
axios.defaults.baseURL = 'https://api.bitsems.co.za'


Vue.config.productionTip = false
Vue.prototype.axios = axios
Vue.use(DatetimePicker)
Vue.use(VueToast, {
  position: 'top-right',
  duration:0
});

new Vue({
  vuetify,
  router,
  store,
  beforeCreate() {
    if (localStorage.getItem('token')) {
      this.$store.dispatch('setCurrentUser', localStorage.getItem('token'))
    }
  },
  render: h => h(App)
}).$mount('#app')